import styled from 'styled-components';
import { Input, Select } from 'antd';

export const StyledFlexDiv = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.space_3};
  margin-bottom: ${({ theme }) => theme.spacing.space_3};
`;

export const StyledInput = styled(Input)`
  width: 100%;
  height: ${({ theme }) => theme.spacing.space_5};
  margin-top: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  display: block;
  margin-top: ${({ theme }) => theme.spacing.space_2};

  .ant-select-selector {
    height: ${({ theme }) => theme.spacing.space_5} !important;
  }
`;
